<template>
  <div class="">
    <Modal
      v-model="distriServeListModal"
            width="600"
            :title="distriServeTitle"
            :mask-closable="false"
            :loading="loading"
            @on-ok="distriServeList('distriServeListForm')"
        >
      <Form
        ref="distriServeListForm"
        :model="distriServeListForm"
        :rules="ruleValidate"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="选择客服"
        prop="customServiceUserId"
        label-for="customServiceUserId"
      >
        <Select
          clearable
          filterable
          element-id="customServiceUserId"
          class="search-input"
          placeholder="请选择当前专属客服"
          v-model="distriServeListForm.customServiceUserId"
        >
          <Option
            v-for="orderType in serveroleList"
            :key="orderType.id"
            :value="orderType.id+''"
          >{{orderType.name}}</Option>
        </Select>
      </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    agentId: {
      type: Number
    },
    distriServeTitle: {
      type: String
    },
    epIds: {
      type: [String, Number]
    },
    distriServeModal: {
      type: Boolean,
      required: true
    },
    distriServeRow: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      visible: false,
      serveroleList: [],
      distriServeListModal: this.distriServeModal,
      distriServeListForm: {
        epIds: '',
        customServiceUserId: ''
      },
      ruleValidate: {
        customServiceUserId: [
        { required: true, message: '当前专属客服不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
   // 保存编辑数据
    distriServeList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.distriServeListForm
          }
          let url = '/enterprise/mgr/updateCustomService'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              let msg = '修改成功'
              this.$Message.success(msg)
              this.distriServeListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      if (this.distriServeRow) {
        this.agentId = this.distriServeRow.id
        this.distriServeListForm.epIds = this.distriServeRow.id
      } else {
        this.distriServeListForm.epIds = this.epIds
      }
    }
  },
  watch: {
    distriServeModal (val) {
      this.distriServeListModal = val
      if (val) {
        this.reload()
      }
    },
    distriServeListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  created () {
    this.$http.get('/user/listBySysrole?sysrole=8').then(res => {
      this.serveroleList = res.data
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/DistriCustomerService.vue